import { Constants } from '@/constants/constants';
import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { store } from '../..';

@Module({ dynamic: true, store, name: 'jgrowStatusModule', namespaced: true })
class JgrowStatusModule extends VuexModule {
  isJgrow: boolean = process.env.VUE_APP_SERVICE_NAME == Constants.ServiceNameJgrow;

  @Action
  updateDocumentTitle() {
    document.title = "J's GROW";
  }
}
export const jgrowStatusModule = getModule(JgrowStatusModule);
